<!-- eslint-disable -->
<template>
    <span>
    <!-- human readable name -->
    <span v-if="isInitiailized === true && DV_hidePartnerOrg !== true">
      <span 
      v-for="(parent_org_uid,index) in orgParentList"
      :key="index+ parent_org_uid"
      >
        <c7-org-name-label 
        :orgUid="parent_org_uid"
      ></c7-org-name-label>
      >       
      </span>
    </span>
    </span>
</template>

<script>
/* eslint-disable */
/* the reason  '../labels/' is before the files in the same directory is to prevent NPM 
compile warnings as it sees ./X as different than ../label/X if when this component is put in 
another component that uses one of the children components in this componenet
*/
import c7OrgNameLabel from "../Labels/c7OrgNameLabel";
export default {
  name: "c21OrgParentsLabel",
  components: { c7OrgNameLabel },
  props: ["orgUid","stopOrgUid"],
  data() {
    return {
      orgParentList: [],
      isInitiailized: false,
      DV_hidePartnerOrg: true
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.startListener();
    });
  },
  methods: {
    startListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (
        window.vue_instance.$data.watchdog.watchdogDbConnected === true &&
        typeof this.orgUid === "string" &&
        this.orgUid in window.G_watchdog_data.IV_org_parents_lookup &&
        window.G_watchdog_data.IV_org_parents_lookup[this.orgUid] !== null &&
        window.G_watchdog_data.IV_org_parents_lookup[this.orgUid] !== undefined &&
        Array.isArray(window.G_watchdog_data.IV_org_parents_lookup[this.orgUid]) === true
      ) {
        var parent_list = JSON.parse(JSON.stringify(window.G_watchdog_data.IV_org_parents_lookup[this.orgUid]));
        

        if (typeof this.stopOrgUid === "string") {
          var splice_count = 1;
          for (var index in parent_list) {
              if (parent_list[index] === this.stopOrgUid) {
                parent_list.splice(0,splice_count);
                break;
              }
              splice_count += 1;

          }
        }
        this.orgParentList = parent_list;
        this.isInitiailized = true;
      } else {
        setTimeout(this.startListener, 200);
      }
    },
  },
  watch: {
        userHasPermissionsFlag: function(val) {      
      //user can always see orgs they have access too and systems under them
      if(this.userHasPermissionsFlag === true) {
        this.DV_hidePartnerOrg = false;
        return;
      }
      //don't show partner orgs and partner sub-orgs to those who don't have access to them, they are subscribers and want to their org as the top level one      
       if(this.orgUid in window.G_watchdog_data.IV_org_meta_data &&
        'type' in window.G_watchdog_data.IV_org_meta_data[this.orgUid] &&
              ( window.G_watchdog_data.IV_org_meta_data[this.orgUid]['type'] === "1" ||  
              window.G_watchdog_data.IV_org_meta_data[this.orgUid]['type'] === "8")
      ) {
        this.DV_hidePartnerOrg = true;
        return;
        }

      //even if the user doesn't have access to the org they should see non-partner parent orgs
      this.DV_hidePartnerOrg = true;
    },

  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Labels/c21OrgParentsLabel.vue